module.exports = __webpack_public_path__ + "img/search.37e7e1e9.svg";